import { Component, Input } from '@angular/core';
import { ParagraphBlock } from 'src/app/core/models/message-blocks';
import { MessageBlockBaseDirective } from '../../message-block-base.directive';

@Component({
  selector: 'app-mr-paragraph',
  templateUrl: './mr-paragraph.component.html',
  styleUrls: ['./mr-paragraph.component.scss'],
})
export class MrParagraphComponent extends MessageBlockBaseDirective {
  @Input() block!: ParagraphBlock;
}
